<template>
  <div class="px-20">
    <vs-row>
      <vs-col vs-type="flex" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
        <vx-card class="mt-5">
          <div class="flex">
            <h2 class="my-5">สมัครผู้ใช้งาน |</h2> 
            <p class="mt-6 mx-5 pt-1">
              <a @click="$router.push('/pages/login')">ลงชื่อเข้าใช้งาน</a>
            </p>
          </div>
          <vs-divider />
          <p class="my-5">ประเภทบุคคล</p>
          <div>
            <vs-radio
              v-model="personType"
              vs-value="chkOwner"
              class="mb-3 ml-10"
              >บุคคลทั่วไป</vs-radio
            >
            <vs-radio
              v-model="personType"
              vs-value="chkJuristic"
              class="mb-3 ml-10"
              >นิติบุคคล</vs-radio
            >
          </div>
        </vx-card>
      </vs-col>
    </vs-row>
    <div class="px-4 pt-4 pb-16" v-if="vesselType != 'tankerBoat'">
      <owner-register v-show="personType == 'chkOwner'"></owner-register>
      <juristic-register
        v-show="personType == 'chkJuristic'"
      ></juristic-register>
    </div>
    <div class="px-4 pt-4 pb-16" v-else>
      <juristic-register />
    </div>
  </div>
</template>

<script>
import OwnerRegister from "./Owner/OwnerRegister";
import JuristicRegister from "./Juristic/JuristicRegister";
export default {
  name: "",
  components: {
    OwnerRegister,
    JuristicRegister,
  },
  data() {
    return {
      vesselType: "boat",
      personType: "chkOwner",
      personTypeTanker: "chkJuristicTanker",
      boat: true,
      tankerBoat: false,
      chkOwner: true,
      chkJuristic: false,
    };
  },
  watch: {
    boat: function () {
      if (this.boat == true) {
        this.tankerBoat = false;
      }
    },
    tankerBoat: function () {
      if (this.tankerBoat == true) {
        this.boat = false;
        this.chkOwner = false;
        this.chkJuristic = false;
      }
    },
    chkOwner: function () {
      if (this.chkOwner == true) {
        this.chkJuristic = false;
      }
    },
    chkJuristic: function () {
      if (this.chkJuristic == true) {
        this.chkOwner = false;
      }
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
